import { api } from "./api";

const CHUNK = 4 * 1024 * 1024;

async function withRetry(fn, tries = 3) {
  for (let attempt = 1; ; attempt++) {
    try {
      return await fn();
    } catch (err) {
      const status = err?.response?.status;
      if (attempt >= tries || (status && status < 500)) throw err;
      await new Promise((r) => setTimeout(r, 800 * attempt));
    }
  }
}

// Sends the file in 4MB pieces so large videos get past proxy body-size limits.
export async function uploadChunked(url, file, contentType, onProgress) {
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const uploadId = crypto.randomUUID();
  let data;
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    Object.entries({ upload_id: uploadId, index: i, total, filename: file.name, content_type: contentType }).forEach(([k, v]) => fd.append(k, v));
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    const onUploadProgress = (e) => onProgress?.(Math.min(99, Math.round(((i * CHUNK + (e.loaded || 0)) / Math.max(file.size, 1)) * 100)));
    ({ data } = await withRetry(() => api.post(url, fd, { timeout: 120000, onUploadProgress })));
  }
  return data;
}
